import { INITIALIZE_AGREEMENT_VERSION } from 'src/app/pages/shared/constants';
import { PrivacyPolicyVersion } from '../privacy-policy/privacy-policy-version';
import { TermsOfServiceVersion } from '../terms-of-service/terms-of-service-version';

export class AgreementStatuses {
  readonly privacyPolicy: PrivacyPolicyVersion;
  readonly termsOfService: TermsOfServiceVersion;
  constructor(
    privacyPolicy: number = INITIALIZE_AGREEMENT_VERSION,
    termsOfService: number = INITIALIZE_AGREEMENT_VERSION,
  ) {
    this.privacyPolicy = new PrivacyPolicyVersion(privacyPolicy);
    this.termsOfService = new TermsOfServiceVersion(termsOfService);
  }

  eq(other: AgreementStatuses) {
    return (
      this.privacyPolicy.eq(other.privacyPolicy) &&
      this.termsOfService.eq(other.termsOfService)
    );
  }
}
